import { render, staticRenderFns } from "./PendingRole.vue?vue&type=template&id=49ef9e71&scoped=true"
import script from "./PendingRole.vue?vue&type=script&lang=js"
export * from "./PendingRole.vue?vue&type=script&lang=js"
import style0 from "./PendingRole.vue?vue&type=style&index=0&id=49ef9e71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef9e71",
  null
  
)

export default component.exports